import React from "react";
import "../styles/BrandLogoMarquee.css";
// import shopifyPlus from "../assets/ShopifyPlusPartner.png";
// import clickFunnels from "../assets/ClickFunnels-logo.png";
// import CheckoutChamp from "../assets/checkout-champ-logo.png";
// import printify from "../assets/printify-logo.png";
// import printful from "../assets/printful-logo.png";
// import AliExpress from "../assets/Aliexpress_logo.png";
// import Zendrop from "../assets/ZendropLogo.png";
// import Recharge from "../assets/Recharge.png";
// import Klaviyo from "../assets/Klaviyo-2.png";

export default function BrandLogoMarquee() {
  // Sample brand logos - replace with your actual brand logos
  const brandLogos = [
    {
      id: 1,
      name: "Shopify",
      logo: "https://upload.wikimedia.org/wikipedia/commons/0/0e/Shopify_logo_2018.svg",
    },
    {
      id: 2,
      name: "Shopify Plus",
      logo: "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/ShopifyPlusPartner.png?v=1765265818",
    },
    {
      id: 3,
      name: "ClickFunnels",
      logo: "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/ClickFunnels-logo.png?v=1765265818",
    },
    {
      id: 4,
      name: "CheckoutChamp",
      logo: "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/checkout-champ-logo.png?v=1765265818",
    },
    {
      id: 5,
      name: "Printify",
      logo: "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/printify-logo.png?v=1765265818",
    },
    {
      id: 6,
      name: "Printful",
      logo: "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/printful-logo_2e83fd7d-3743-4864-abb5-56fefec9395f.png?v=1765529973",
    },
    {
      id: 7,
      name: "AliExpress",
      logo: "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/Aliexpress_logo.png?v=1765265818",
    },
    {
      id: 8,
      name: "Zendrop",
      logo: "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/ZendropLogo.png?v=1765265818",
    },
    {
      id: 9,
      name: "Recharge",
      logo: "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/Recharge.png?v=1765265818",
    },
    {
      id: 10,
      name: "Klaviyo",
      logo: "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/Klaviyo-2.png?v=1765265818",
    },
  ];

  return (
    <div className="brand_marquee_main_section">
      {/* Section Header */}
      {/* <div className="brand_marquee_header_container">
        <p className="brand_marquee_subtitle_text">TRUSTED BY LEADING BRANDS</p>
        <h2 className="brand_marquee_title_heading">Companies We Work With</h2>
      </div> */}

      {/* Marquee Container */}
      <div className="brand_marquee_slider_wrapper">
        <div className="brand_marquee_track_container">
          {/* First set of logos */}
          <div className="brand_marquee_logos_group">
            {brandLogos.map((brand) => (
              <div
                key={`first-${brand.id}`}
                className="brand_marquee_logo_item"
              >
                <img
                  loading="lazy"
                  src={brand.logo}
                  alt={`${brand.name} logo`}
                  className="brand_marquee_logo_image" width={120} height={40}
                />
              </div>
            ))}
          </div>
          {/* Duplicate set for seamless loop */}
          <div className="brand_marquee_logos_group">
            {brandLogos.map((brand) => (
                <div
                  key={`second-${brand.id}`}
                  className="brand_marquee_logo_item"
                >
                  <img
                    loading="lazy"
                    src={brand.logo}
                    alt={`${brand.name} logo`}
                    className="brand_marquee_logo_image" width={120} height={40}
                  />
                </div>
              ))}
          </div>
        </div>
      </div>

      {/* Alternative: Reverse Direction Marquee */}
      {/* <div className="brand_marquee_slider_wrapper_reverse">
        <div className="brand_marquee_track_container_reverse">

          <div className="brand_marquee_logos_group_reverse">
            {brandLogos.map((brand) => (
              <div
                key={`reverse-first-${brand.id}`}
                className="brand_marquee_logo_item"
              >
                <img
                  loading="lazy"
                  src={brand.logo}
                  alt={`${brand.name} logo`}
                  className="brand_marquee_logo_image" width={120} height={40}
                />
              </div>
            ))}
          </div>
         
          <div className="brand_marquee_logos_group_reverse">
            {brandLogos.map((brand) => (
              <div
                key={`reverse-second-${brand.id}`}
                className="brand_marquee_logo_item"
              >
                <img
                  loading="lazy"
                  src={brand.logo}
                  alt={`${brand.name} logo`}
                  className="brand_marquee_logo_image" width={120} height={40}
                />
              </div>
            ))}
          </div>
        </div>
      </div> */}
    </div>
  );
}
